<template>
    <div>
        <div class="page-title">User Account Setting</div>
        <div class="page-box">
            <div class="page-box-title">
               <div>
                <el-button type="primary" @click="show3 = !show3">Filter</el-button>
                <el-button icon="el-icon-plus" v-if="userInfo.roleId === roleAdminId" type="warning" @click="onAdd">Add</el-button>
               </div>
            </div>
            <div class="search-box">
                <el-collapse-transition>
                    <el-form label-width="180px" ref="ruleForm" v-show="show3" :model="formLabelAlign">
                        <el-form-item label="Email Address">
                            <el-input v-model="formLabelAlign.emailLike"></el-input>
                        </el-form-item>
                        <el-form-item label="Role">
                            <el-select v-model="formLabelAlign.roleId" placeholder="">
                                    <el-option
                                    v-for="item in userRoleSearch"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                        </el-form-item>
                        <el-form-item label="Status">
                            <el-select v-model="formLabelAlign.status" placeholder="">
                                    <el-option
                                    v-for="item in userStatus"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button icon="el-icon-search" type="warning" @click="onSubmit">Search</el-button>
                            <el-button icon="el-icon-refresh-left" @click="onReset">Reset</el-button>
                        </el-form-item>
                    </el-form>
                </el-collapse-transition>
            </div>
            <el-table :data="tableData" style="width: 100%;">
                <el-table-column
                    prop="email"
                    label="Email Address"
                    >
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="Status"
                    >
                    <template slot-scope="{row}">
                        <span>{{row.status | statusFilters}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="roleName"
                    label="Role">
                </el-table-column>
                <el-table-column
                    prop="createdAt"
                    label="Member For">
                     <template slot-scope="{row}">
                          <span>{{row.createdAt | formatDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="lastAccessAt"
                    label="Last Access">
                    <template slot-scope="{row}">
                          <span>{{row.lastAccessAt | fromNow}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                        <template slot-scope="{row}">
                            <span v-if="(userInfo.roleId !== roleManagerId && userInfo.roleId !== roleClerkId) || (row.roleName !='applicant' && row.roleName !='manger')" class="action-link cursor" @click="onEdit(row.id)">Edit</span>&nbsp;&nbsp;
                            <span v-if="userInfo.roleId !== roleManagerId && userInfo.roleId !== roleClerkId" class="action-link cursor" @click="onDelete(row.id)">Delete</span>
                        </template>
                </el-table-column>
            </el-table>
             <pagination
                v-show="total > 0"
                :total="total"
                layout="total, sizes, prev, pager, next"
                :page.sync="formLabelAlign._page"
                :limit.sync="formLabelAlign._limit"
                @pagination="getUserPagination"
            />
            <loadingSlotDialog @close="close" :centerDialogVisible="centerDialogVisible">
                    <div class="dialog-text"> Add Account</div>
                    <userAccountSettingFrom :ruleForm="ruleForm"></userAccountSettingFrom>
                    <el-button @click="onAddConfirm" type="warning">Confirm</el-button>
                    <el-button @click="onAddCancel">Cancel</el-button>
            </loadingSlotDialog>
            <loadingSlotDialog :centerDialogVisible="deleteCenterDialogVisible" @close="deleteClose">
                <img src="@/assets/images/feather-alert-circle.png"/>
                <div class="dialog-text">Are you sure to delete this item ?</div>
                <el-button @click="onConfirm" type="danger">Confirm</el-button>
                <el-button @click="onCancel">Cancel</el-button>
           </loadingSlotDialog>
        </div>
    </div>
</template>

<script>
    import {getUser,addUser,deleteUser} from '@/api/admin/user'
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import pagination from '@/components/Pagination'
    import userAccountSettingFrom from './components/userAccountSettingFrom'
    export default {
        components:{loadingSlotDialog,userAccountSettingFrom,pagination},
        filters:{
            statusFilters(v){
              return  v ? 'Inactive' : 'Active'
            }
        },
        data() {
            return {
                show3: true,
                itemId:0,
                total:0,
                tableData:[],
                centerDialogVisible:false,
                deleteCenterDialogVisible:false,
                ruleForm:{
                    email: null, 
                    password: null, 
                    status: null, 
                    roleId: null, 
                    assignApplicationFormType: null
                },
                formLabelAlign: {
                    emailLike: null, 
                    _page: 1,
                    _limit: 10,
                    status: null, 
                    roleId: null
                }
            }
        },
        created(){
            this.getUser()
        },
        methods:{
            onReset(){
                Object.keys(this.formLabelAlign).forEach((key)=>{
                    this.formLabelAlign[key] = null
                    if(key === '_limit'){
                        this.formLabelAlign[key] = 10
                    }
                    if(key === '_page'){
                        this.formLabelAlign[key] = 1
                    }
                })
                this.getUser()
            },
            onSubmit(){
                this.getUser()
            },
            onConfirm(){
                this.deleteUser()
            },
            onCancel(){
                 this.deleteCenterDialogVisible = false
            },
            onEdit(id){
                 this.$router.push({path:`/admin/userAccountSetting/${id}/edit`})
            },
            onDelete(id){
                this.itemId = id
                this.deleteCenterDialogVisible = true
            },
            onAddConfirm(){
                this.addUser()
            },
            onAddCancel(){
                 this.centerDialogVisible = false
            },
            deleteClose(v){
                this.deleteCenterDialogVisible = v
            },
            close(v){
                this.centerDialogVisible = v
            },
            onAdd(){
               this.centerDialogVisible = true
            },
            addUser(){
                if(this.ruleForm.roleId === this.roleClerkId){
                   this.ruleForm.assignApplicationFormType = this.ruleForm.assignApplicationFormType.toString()
                }
                
                addUser(this.ruleForm).then(()=>{
                  Object.keys(this.ruleForm).forEach((key)=>{
                      this.ruleForm[key] = null
                  })
                  this.getUser()
                }).finally(()=>{
                     this.centerDialogVisible = false
                })
            },
            deleteUser(){
                deleteUser(this.itemId).then(()=>{
                    this.getUser()
                }).finally(()=>{
                     this.deleteCenterDialogVisible = false
                })
            },
            getUserPagination(val){
                this.formLabelAlign._page = val.page
                this.formLabelAlign._limit = val.limit
                this.getUser()
            },
            getUser(){
                let from = {
                    emailLike: this.formLabelAlign.emailLike, 
                    status: this.formLabelAlign.status, 
                    roleId: this.formLabelAlign.roleId,
                    _page: this.formLabelAlign._page - 1,
                    _limit: this.formLabelAlign._limit,
                }
                getUser(from).then((v)=>{
                    this.tableData = v.data
                    this.total = Number(v.headers["x-total-count"]);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding-bottom: 20px;
}
.page-box-title{
    display: flex;
    border-bottom: 1px solid #707070;
    justify-content: space-between;
    padding: 0 47px;
    padding-top:46px;
    padding-bottom: 27px;
}
.search-box{
    padding-top: 50px;
    padding-bottom: 40px;
    padding-left: 50px;
    padding-right: 50px;
}
.dialog-text{
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
}
  .el-button--primary {
    width: auto;
    background-color:  #060C60;
    border-color: #060C60;
    font-size: 20px;
    font-weight: bold;
  }
</style>